import React, { forwardRef } from 'react';
import { Scatter } from 'react-chartjs-2';

const RiskReturnScatterChart = forwardRef(({ performance, volatilityData, colours = {} }, ref) => {
  if (!performance || !volatilityData) {
    return <div className="chart-placeholder">No risk/return data available</div>;
  }

  const portfolioVol = volatilityData.portfolio_vol ?? volatilityData.volatility ?? null;
  const peerVol = volatilityData.peer_vol ?? volatilityData.peer_volatility ?? null;
  const portfolioReturn = performance.return_1y ?? null;
  const peerReturn = performance.peer_return_1y ?? null;

  if (portfolioVol === null || portfolioReturn === null) {
    return <div className="chart-placeholder">Insufficient data for scatter plot</div>;
  }

  const datasets = [
    {
      label: 'Portfolio',
      data: [{ x: portfolioVol, y: portfolioReturn }],
      backgroundColor: colours.scatter_portfolio || '#072040',
      pointRadius: 8,
      pointHoverRadius: 10,
    },
  ];

  if (peerVol !== null && peerReturn !== null) {
    datasets.push({
      label: 'Peer',
      data: [{ x: peerVol, y: peerReturn }],
      backgroundColor: colours.scatter_peer || '#f0a500',
      pointRadius: 8,
      pointHoverRadius: 10,
    });
  }

  const chartData = { datasets };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: { font: { size: 10 }, boxWidth: 20, boxHeight: 2, padding: 5, usePointStyle: true },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: Vol ${ctx.parsed.x.toFixed(1)}%, Return ${ctx.parsed.y.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: {
        title: { display: true, text: 'Volatility (%)', font: { size: 10 } },
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: { font: { size: 10 }, callback: (val) => `${val}%` },
      },
      y: {
        title: { display: true, text: 'Return (%)', font: { size: 10 } },
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: { font: { size: 10 }, callback: (val) => `${val}%` },
      },
    },
  };

  return (
    <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
      <Scatter ref={ref} data={chartData} options={options} />
    </div>
  );
});

RiskReturnScatterChart.displayName = 'RiskReturnScatterChart';
export default RiskReturnScatterChart;
